export default __webpack_public_path__ + "static/media/B4693B00-01D3-412F-BF12-833E82A3E313_1_105_c.9851d2e3.jpeg";